import snakecaseKeys from 'snakecase-keys';
import { BackgroundCheck } from '../../../entities/BackgroundCheck';
import { ApiService } from '../../ApiService';

interface ShowParams {
  id?: number;
  applicationExternalId?: number;
}

export class BackgroundCheckService {
  public static show(params: ShowParams): Promise<BackgroundCheck> {
    return ApiService.get<BackgroundCheck>(
      '/api/v1/background_checks/background_check',
      snakecaseKeys(params),
    );
  }
}
